import React from 'react';
import { Link } from 'react-router-dom';

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      {/* Modern Header */}
      <header className="bg-white/80 backdrop-blur-md shadow-lg border-b border-gray-200/50 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">P</span>
              </div>
              <Link to="/" className="text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent hover:from-blue-700 hover:to-purple-700 transition-all duration-300">
                CONSORCIO PARQUEO AMIGO
              </Link>
            </div>
            <div className="flex space-x-4">
              <Link 
                to="/login" 
                className="px-6 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                Iniciar Sesión
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium mb-6">
            <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
            Protección de Datos
          </div>
          <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-purple-800 bg-clip-text text-transparent mb-4">
            Política de Privacidad
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Protegemos su información personal con los más altos estándares de seguridad y transparencia
          </p>
          <div className="mt-6 flex items-center justify-center space-x-4 text-sm text-gray-500">
            <span>Última actualización: Enero 2025</span>
            <span>•</span>
            <span>Versión 2.0</span>
          </div>
        </div>

        {/* Content Cards */}
        <div className="space-y-8">
          
          {/* Company Info Card */}
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 px-8 py-6">
              <h2 className="text-2xl font-bold text-white mb-2">Nuestra Empresa</h2>
              <p className="text-blue-100">Información legal y de contacto</p>
            </div>
            <div className="p-8">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Datos de la Empresa</h3>
                  <div className="space-y-3">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Razón Social:</span>
                      <span className="font-medium">CONSORCIO PARQUEO AMIGO-SANTO DOMINGO</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">RUC:</span>
                      <span className="font-medium">2390642752001</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Representante Legal:</span>
                      <span className="font-medium">CISNEROS MANTILLA EDWIN PATRICIO</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Estado:</span>
                      <span className="font-medium text-green-600">ACTIVO</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Régimen:</span>
                      <span className="font-medium">RIMPE - EMPRENDEDOR</span>
                    </div>
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-4">Información de Contacto</h3>
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3">
                      <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                      </svg>
                      <span>privacidad@parqueoamigo.com</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                      </svg>
                      <span>+593 99 463 3688</span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                      </svg>
                      <span>Santo Domingo de los Tsáchilas, Ecuador</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Privacy Policy Sections */}
          <div className="grid md:grid-cols-2 gap-8">
            
            {/* Left Column */}
            <div className="space-y-6">
              
              {/* Section 1 */}
              <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all duration-300">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                    <span className="text-blue-600 font-bold">1</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">Información que Recopilamos</h3>
                </div>
                <div className="text-gray-700 space-y-3">
                  <p>Recopilamos información necesaria para brindar nuestros servicios de estacionamiento:</p>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Datos del vehículo (placa, tipo)</li>
                    <li>Información del propietario</li>
                    <li>Datos de ubicación y GPS</li>
                    <li>Información de transacciones</li>
                    <li>Datos de uso del sistema</li>
                  </ul>
                </div>
              </div>

              {/* Section 2 */}
              <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all duration-300">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center mr-4">
                    <span className="text-purple-600 font-bold">2</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">Cómo Utilizamos su Información</h3>
                </div>
                <div className="text-gray-700 space-y-3">
                  <p>Su información se utiliza exclusivamente para:</p>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Gestionar tickets de estacionamiento</li>
                    <li>Procesar pagos y facturación</li>
                    <li>Mejorar nuestros servicios</li>
                    <li>Cumplir obligaciones legales</li>
                    <li>Garantizar la seguridad del sistema</li>
                  </ul>
                </div>
              </div>

              {/* Section 3 */}
              <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all duration-300">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center mr-4">
                    <span className="text-green-600 font-bold">3</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">Seguridad de Datos</h3>
                </div>
                <div className="text-gray-700 space-y-3">
                  <p>Implementamos las más altas medidas de seguridad:</p>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Encriptación de datos en tránsito y reposo</li>
                    <li>Acceso restringido y monitoreado</li>
                    <li>Firewalls y protección avanzada</li>
                    <li>Auditorías regulares de seguridad</li>
                    <li>Cumplimiento de estándares internacionales</li>
                  </ul>
                </div>
              </div>

            </div>

            {/* Right Column */}
            <div className="space-y-6">
              
              {/* Section 4 */}
              <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all duration-300">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-4">
                    <span className="text-orange-600 font-bold">4</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">Sus Derechos</h3>
                </div>
                <div className="text-gray-700 space-y-3">
                  <p>Usted tiene derecho a:</p>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Acceder a su información personal</li>
                    <li>Corregir datos inexactos</li>
                    <li>Solicitar eliminación de datos</li>
                    <li>Oponerse al procesamiento</li>
                    <li>Portabilidad de sus datos</li>
                    <li>Retirar consentimiento</li>
                  </ul>
                </div>
              </div>

              {/* Section 5 */}
              <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all duration-300">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center mr-4">
                    <span className="text-red-600 font-bold">5</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">Compartir Información</h3>
                </div>
                <div className="text-gray-700 space-y-3">
                  <p>No vendemos ni compartimos su información, excepto:</p>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Con su consentimiento explícito</li>
                    <li>Para cumplir obligaciones legales</li>
                    <li>Con proveedores de servicios autorizados</li>
                    <li>Para proteger derechos y seguridad</li>
                  </ul>
                </div>
              </div>

              {/* Section 6 */}
              <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-6 hover:shadow-xl transition-all duration-300">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 bg-indigo-100 rounded-lg flex items-center justify-center mr-4">
                    <span className="text-indigo-600 font-bold">6</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">Cookies y Tecnologías</h3>
                </div>
                <div className="text-gray-700 space-y-3">
                  <p>Utilizamos cookies para mejorar su experiencia:</p>
                  <ul className="list-disc pl-6 space-y-1 text-sm">
                    <li>Cookies esenciales para el funcionamiento</li>
                    <li>Cookies de análisis y rendimiento</li>
                    <li>Cookies de personalización</li>
                    <li>Control total desde su navegador</li>
                  </ul>
                </div>
              </div>

            </div>

          </div>

          {/* Contact Section */}
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl shadow-xl p-8 text-white">
            <div className="text-center mb-6">
              <h2 className="text-3xl font-bold mb-2">¿Tiene Preguntas?</h2>
              <p className="text-blue-100">Estamos aquí para ayudarle con cualquier consulta sobre privacidad</p>
            </div>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                </div>
                <h3 className="font-semibold mb-2">Email</h3>
                <p className="text-blue-100">privacidad@parqueoamigo.com</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                </div>
                <h3 className="font-semibold mb-2">Teléfono</h3>
                <p className="text-blue-100">+593 99 463 3688</p>
              </div>
              <div className="text-center">
                <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                  </svg>
                </div>
                <h3 className="font-semibold mb-2">Oficina</h3>
                <p className="text-blue-100">Santo Domingo de los Tsáchilas</p>
              </div>
            </div>
          </div>

        </div>

        {/* Footer */}
        <div className="mt-12 text-center">
          <Link 
            to="/" 
            className="inline-flex items-center px-8 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
          >
            <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
            Volver al Inicio
          </Link>
        </div>
      </main>
    </div>
  );
}

export default PrivacyPolicy; 